import React, { createContext, useState, useContext, ReactNode } from "react";
import { ITaskData } from "@origin-digital/reporting-client";

export type ITracking = {
  [key in ITaskData["action"]]?: boolean;
};

export interface ITrackingContext {
  context: ITracking;
  setTrackingContext(context: Partial<ITracking>): void;
}

export const TrackingContext = createContext<ITrackingContext>({
  context: {},
  setTrackingContext: /* istanbul ignore next */ () => undefined,
});

export const mergeContext =
  ({ setTrackingContext, context }: ITrackingContext) =>
  (nextContext: Partial<ITracking>): void =>
    setTrackingContext({
      ...context,
      ...nextContext,
    });

export const useTrackingContext = (): ITrackingContext =>
  useContext<ITrackingContext>(TrackingContext);

export const TrackingContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [context, setTrackingContext] = useState<ITracking>({});

  return (
    <TrackingContext.Provider
      value={{
        context,
        setTrackingContext: mergeContext({ setTrackingContext, context }),
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};
